export default __webpack_public_path__ + "static/media/leaf.c9d382ae.png";